export default __webpack_public_path__ + "static/media/signpost-content.346d3b39.md";